import React from "react";
import { Modal, Row, Col } from "antd";
import RenderDesingProcessData from "../render-desing-process-data";
import RenderFigureData from "../render-figure-data";

//import multilanguage library
import { useTranslation } from 'react-i18next'

const ModalDesingProcess = ({ visible, handleVisible, desing }) => {
  const handleOk = () => {
    handleVisible(false);
  };

  //To translate text
  const { t } = useTranslation();

  return (
    desing && (
      <div>
        <Modal
          title={(desing.desingName ? desing.desingName : t('text.text_no_linked') ) + " - " + desing.article.articleName}
          visible={visible}
          onOk={handleOk}
          onCancel={handleOk}
          width="70vw"
        >
          <Row>
            <Col span={12}>
              <RenderFigureData selectedArticle={desing.article} />
            </Col>
            <Col span={12}>
              <RenderDesingProcessData selectedProcessDesing={desing.desingName && desing} />
            </Col>
          </Row>
        </Modal>
      </div>
    )
  );
};

export default ModalDesingProcess;
